module.exports = __webpack_public_path__ + "img/dasboard.d111d764.svg";